module.exports = __webpack_public_path__ + "static/CP86 one pager-055158108a261f84dfe689c1bf9bcdd1.pdf";